import type { SxProps, Theme } from '@mui/material/styles';

import { lighten } from '@mui/material/styles';

// ----------------------------------------------------------------------
// Card-level styles
// ----------------------------------------------------------------------

export const solidCard = {
  backgroundImage: 'none',
  bgcolor: 'container.low',
  border: 'none',
  boxShadow: 'none',
};

// Hover backgrounds for clickable cards — a subtle lift just above the card's
// resting container.low, kept darker than container.medium.
export const solidCardHover = {
  bgcolor: (theme: Theme) => lighten(theme.palette.container.low, 0.04),
};

// ----------------------------------------------------------------------
// Item-level styles (rows inside cards)
// ----------------------------------------------------------------------

export const solidItem = {
  bgcolor: 'container.medium',
};

// ----------------------------------------------------------------------
// Small circular icon-button used on card rows
// ----------------------------------------------------------------------

export const solidIconButton = {
  bgcolor: 'grey.800',
  border: '1px solid',
  borderColor: 'grey.700',
  '&:hover': { bgcolor: 'grey.800' },
};

// ----------------------------------------------------------------------
// Responsive 3-column card width (dashboard & devices grids)
// ----------------------------------------------------------------------

export const responsiveCardWidth: SxProps<Theme> = {
  width: {
    xs: '100%',
    sm: 'calc(50% - 10px)',
    md: 'calc(33.333% - 14px)',
  },
};
